import { Component, OnInit, OnDestroy, Input, NgZone, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';

import { Alert, AlertType } from '@app/shared/_models/alert';
import { AlertService } from '@app/shared/alert.service';

import { MatSnackBar, MatSnackBarConfig, MatSnackBarVerticalPosition, MatSnackBarHorizontalPosition } from '@angular/material/snack-bar';

@Component({
		standalone: true,
    selector: 'app-alert',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: 'alert.component.html'
})
export class AlertComponent implements OnInit, OnDestroy {
    @Input() id = 'default-alert';

    alertSubscription!: Subscription;
    routeSubscription!: Subscription;

    horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    verticalPosition: MatSnackBarVerticalPosition = 'bottom';
    autoHide: number = 10_000;

    constructor(private router: Router, private alertService: AlertService, private snackBar: MatSnackBar) { }

    ngOnInit() {
        this.alertSubscription = this.alertService.onAlert(this.id)
            .subscribe(alert => {
				console.log("[AlertComponent] alert: " + JSON.stringify(alert));
                if (alert && alert.message) {
					this.open(alert);	
                } else if (alert.type == AlertType.Clear) {
					console.log("[AlertComponent] dismissing snackbar")
					this.snackBar.dismiss();						
				}
            });

        this.routeSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                // this.alertService.clear();				// This is quite good, but for tnrs that closes the snackbar too soon.
            }
        });
    }

    open(alert: Alert) {
        let config = new MatSnackBarConfig();
        config.verticalPosition = this.verticalPosition;
        config.horizontalPosition = this.horizontalPosition;
        config.panelClass = this.cssClass(alert);
        config.duration = this.autoHide;
        if (alert.message) {
            const ref = this.snackBar.open(alert.message, alert.action?.label ?? "X", config);
            const action = alert.action;
            if (action) ref.onAction().subscribe(() => action.run());
        }
    }

    ngOnDestroy() {
        this.alertSubscription.unsubscribe();
        this.routeSubscription.unsubscribe();
    }

    cssClass(alert: Alert): string[] {
        const classes = ['alert', 'alert-dismissible', 'mt-4', 'container'];

        const alertTypeClass = {
            // [AlertType.Success]: 'alert-success',
            // [AlertType.Error]: 'alert-error',
            // [AlertType.Info]: 'alert-info',
            // [AlertType.Warning]: 'alert-warning',
			// [AlertType.Clear]: ''	// This is useless
            [AlertType.Primary]: 'primary',
            [AlertType.Info]: 'info',
            [AlertType.Secondary]: 'secondary',
            [AlertType.tertiary]: 'tertiary',
            [AlertType.Success]: 'success',
            [AlertType.Neutral]: 'neutral',
            [AlertType.NeutralVariant]: 'neutral-variant',
            [AlertType.Warning]: 'warning',
            [AlertType.Error]: 'error',
            [AlertType.Clear]: ''	// This is useless
        };

        if (alert.type !== undefined) {
            classes.push(alertTypeClass[alert.type]);
        }
        return classes;
    }
}
